import { PropTypes } from 'prop-types';
import React from 'react';

import { getPerformanceCookie } from '../../../utils';

const WistiaVideoPlayer = ({ title, wistiaVideoId }) => {
  let performanceCookieOn = false;
  if (typeof window !== 'undefined') {
    performanceCookieOn = getPerformanceCookie(window);
  }

  const handleClick = (e) => {
    e.stopPropagation();
    if (
      typeof window.Optanon !== 'undefined' &&
      typeof window.Optanon.ToggleInfoDisplay === 'function'
    ) {
      window.Optanon.ToggleInfoDisplay();
    }
  };

  return performanceCookieOn ? (
    <div>
      <iframe
        allow="fullscreen"
        allowFullScreen
        autoPlay="false"
        className="wistia_embed"
        frameBorder="0"
        height="100%"
        id="myVideo"
        mozallowfullscreen="true"
        name="wistia_embed"
        scrolling="no"
        src={`https://mailchimp.wistia.com/embed/iframe/${wistiaVideoId}?videoFoam=true"`}
        title={title}
        webkitallowfullscreen="true"
        width="100%"
      />
    </div>
  ) : (
    <div className="no-cookies-enabled">
      <button onClick={handleClick} type="button">
        Please update your privacy settings to enable video play.
      </button>
    </div>
  );
};

WistiaVideoPlayer.propTypes = {
  title: PropTypes.string,
  wistiaVideoId: PropTypes.string,
};

export default WistiaVideoPlayer;
